import {useSelector} from "react-redux";

import {FormActions} from "@pg-mono/form";
import {InteractiveRegionsMapAdapter} from "@pg-rp/interactive-regions-map";

import {IRPStore} from "../../../app/rp_reducer";
import {useLazyGetMapRegionsQuery} from "../../../offer/map/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../offer/map/api/get_map_region_districts_and_surroundings";
import {RegionType} from "../../../region/types/RegionType";
import {useAppDispatch} from "../../../store/hooks";
import {searchFormFields} from "../../constants/search_form_constants";
import {searchFormActions, searchFormSlice} from "../../slices/search_form_slice";
import {hitMapCheckboxToggle} from "../../tracking/hit_map_checkbox_toggle";
import {hitMapSearch} from "../../tracking/hit_map_search";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {ISearchInputRegion, ISearchInputValue} from "../ISearchInputValue";
import {SearchDistanceFilterMobile} from "../SearchDistanceFilterMobile";

interface IProps {
    defaultDistanceValue?: number;
    formValues: SearchFormValuesType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formActions?: FormActions<Record<keyof typeof searchFormFields, any>>;
    search: ISearchInputValue;
    isInModal?: boolean;
    showMainRegionMapOutline?: boolean;
    updateSelectedRegions: (option: ISearchInputValue) => void;
    updateRegionsImmediately?: boolean;
    eventSource?: string;
    openFromLabel?: string | null;
    onSearchSubmit?: () => void;
}

export const SearchInteractiveRegionsMap = (props: IProps) => {
    const {
        isInModal,
        showMainRegionMapOutline,
        updateRegionsImmediately,
        eventSource,
        openFromLabel,
        onSearchSubmit,
        formValues,
        search,
        updateSelectedRegions,
        defaultDistanceValue,
        formActions
    } = props;

    const dispatch = useAppDispatch();
    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response) => {
                return response?.results?.[0] || null;
            });
    };

    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();
    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response) => {
                return response?.results || null;
            });
    };

    const searchFormRegions = search.tabType === SearchTab.Regions ? search.regions : null;

    const interactiveMapRegionSelection = useSelector((state: IRPStore) => state.search[searchFormSlice.name].interactiveMapRegionSelection);
    const interactiveMapOriginRegions = useSelector((state: IRPStore) => state.search[searchFormSlice.name].interactiveMapOriginRegions);

    const syncTemporaryRegionSelectionWithRedux = (selectedRegionIds: (string | number)[]) => {
        dispatch(searchFormActions.updateInteractiveMapRegionSelection(selectedRegionIds));
    };
    const syncRegionSelectionWithRedux = (selectedRegionIds: (string | number)[]) => {
        dispatch(searchFormActions.updateInteractiveMapOriginRegions(selectedRegionIds));
    };

    return (
        <InteractiveRegionsMapAdapter
            isInModal={isInModal}
            showMainRegionMapOutline={showMainRegionMapOutline}
            updateRegionsImmediately={updateRegionsImmediately}
            tracking={{
                onMapInit: ({regionName}) => {
                    hitMapSearch({
                        action: "open",
                        regionName,
                        eventName: eventSource,
                        openFromLabel
                    });
                },
                onMapUpdate: ({regionName}) => {
                    hitMapSearch({
                        action: "apply",
                        regionName,
                        eventName: eventSource,
                        openFromLabel
                    });
                },
                onRegionCheckboxToggle: ({regionName, selectionName, action}) => {
                    hitMapCheckboxToggle({
                        regionName,
                        selectionName,
                        action,
                        eventName: eventSource,
                        openFromLabel
                    });
                }
            }}
            getMainRegion={getMainRegion}
            getDistrictsAndSurroundings={getDistrictsAndSurroundings}
            selectedRegions={searchFormRegions}
            handleUpdateRegions={(selectedRegions, parentRegion) => {
                updateSelectedRegions({
                    ...search,
                    tabType: SearchTab.Regions,
                    regions: selectedRegions.map((item) => {
                        const newItem: ISearchInputRegion = {
                            ...item,
                            full_name: item.short_name,
                            is_leaf_node: false,
                            name: item.short_name,
                            parent: item.type === RegionType.DISTRICT || item.type === RegionType.SURROUNDINGS ? (parentRegion && parentRegion) || null : null
                        };
                        return newItem;
                    })
                });
            }}
            remoteStateSync={{
                temporaryRegionSelectionState: interactiveMapRegionSelection,
                originRegionSelectionState: interactiveMapOriginRegions,
                syncTemporaryRegionSelection: syncTemporaryRegionSelectionWithRedux,
                applyRegionSelection: syncRegionSelectionWithRedux
            }}
            mapBottomLeftSlot={() => (
                <SearchDistanceFilterMobile
                    defaultValue={defaultDistanceValue}
                    values={formValues}
                    onAfterChange={() => null}
                    onChange={(value) => {
                        if (updateRegionsImmediately) {
                            updateSelectedRegions({
                                ...search,
                                ...value
                            });
                        } else {
                            formActions?.update(value);
                        }
                    }}
                    handleDistanceSubmit={() => onSearchSubmit}
                    setDesktopTypeBlendActive={() => null}
                    menuPlacement="top"
                />
            )}
        />
    );
};
import {useSelector} from "react-redux";

import {FormActions} from "@pg-mono/form";
import {InteractiveRegionsMapAdapter} from "@pg-rp/interactive-regions-map";

import {IRPStore} from "../../../app/rp_reducer";
import {useLazyGetMapRegionsQuery} from "../../../offer/map/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../offer/map/api/get_map_region_districts_and_surroundings";
import {RegionType} from "../../../region/types/RegionType";
import {useAppDispatch} from "../../../store/hooks";
import {searchFormFields} from "../../constants/search_form_constants";
import {searchFormActions, searchFormSlice} from "../../slices/search_form_slice";
import {hitMapCheckboxToggle} from "../../tracking/hit_map_checkbox_toggle";
import {hitMapSearch} from "../../tracking/hit_map_search";
import {SearchFormValuesType} from "../../types/SearchFormValuesType";
import {SearchTab} from "../../types/SearchTab";
import {ISearchInputRegion, ISearchInputValue} from "../ISearchInputValue";
import {SearchDistanceFilterMobile} from "../SearchDistanceFilterMobile";

interface IProps {
    defaultDistanceValue?: number;
    formValues: SearchFormValuesType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formActions?: FormActions<Record<keyof typeof searchFormFields, any>>;
    search: ISearchInputValue;
    isInModal?: boolean;
    showMainRegionMapOutline?: boolean;
    updateSelectedRegions: (option: ISearchInputValue) => void;
    updateRegionsImmediately?: boolean;
    eventSource?: string;
    openFromLabel?: string | null;
    onSearchSubmit?: () => void;
}

export const SearchInteractiveRegionsMap = (props: IProps) => {
    const {
        isInModal,
        showMainRegionMapOutline,
        updateRegionsImmediately,
        eventSource,
        openFromLabel,
        onSearchSubmit,
        formValues,
        search,
        updateSelectedRegions,
        defaultDistanceValue,
        formActions
    } = props;

    const dispatch = useAppDispatch();
    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response) => {
                return response?.results?.[0] || null;
            });
    };

    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();
    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response) => {
                return response?.results || null;
            });
    };

    const searchFormRegions = search.tabType === SearchTab.Regions ? search.regions : null;

    const interactiveMapRegionSelection = useSelector((state: IRPStore) => state.search[searchFormSlice.name].interactiveMapRegionSelection);
    const interactiveMapOriginRegions = useSelector((state: IRPStore) => state.search[searchFormSlice.name].interactiveMapOriginRegions);

    const syncTemporaryRegionSelectionWithRedux = (selectedRegionIds: (string | number)[]) => {
        dispatch(searchFormActions.updateInteractiveMapRegionSelection(selectedRegionIds));
    };
    const syncRegionSelectionWithRedux = (selectedRegionIds: (string | number)[]) => {
        dispatch(searchFormActions.updateInteractiveMapOriginRegions(selectedRegionIds));
    };

    return (
        <InteractiveRegionsMapAdapter
            isInModal={isInModal}
            showMainRegionMapOutline={showMainRegionMapOutline}
            updateRegionsImmediately={updateRegionsImmediately}
            tracking={{
                onMapInit: ({regionName}) => {
                    hitMapSearch({
                        action: "open",
                        regionName,
                        eventName: eventSource,
                        openFromLabel
                    });
                },
                onMapUpdate: ({regionName}) => {
                    hitMapSearch({
                        action: "apply",
                        regionName,
                        eventName: eventSource,
                        openFromLabel
                    });
                },
                onRegionCheckboxToggle: ({regionName, selectionName, action}) => {
                    hitMapCheckboxToggle({
                        regionName,
                        selectionName,
                        action,
                        eventName: eventSource,
                        openFromLabel
                    });
                }
            }}
            getMainRegion={getMainRegion}
            getDistrictsAndSurroundings={getDistrictsAndSurroundings}
            selectedRegions={searchFormRegions}
            handleUpdateRegions={(selectedRegions, parentRegion) => {
                updateSelectedRegions({
                    ...search,
                    tabType: SearchTab.Regions,
                    regions: selectedRegions.map((item) => {
                        const newItem: ISearchInputRegion = {
                            ...item,
                            full_name: item.short_name,
                            is_leaf_node: false,
                            name: item.short_name,
                            parent: item.type === RegionType.DISTRICT || item.type === RegionType.SURROUNDINGS ? (parentRegion && parentRegion) || null : null
                        };
                        return newItem;
                    })
                });
            }}
            remoteStateSync={{
                temporaryRegionSelectionState: interactiveMapRegionSelection,
                originRegionSelectionState: interactiveMapOriginRegions,
                syncTemporaryRegionSelection: syncTemporaryRegionSelectionWithRedux,
                applyRegionSelection: syncRegionSelectionWithRedux
            }}
            mapBottomLeftSlot={() => (
                <SearchDistanceFilterMobile
                    defaultValue={defaultDistanceValue}
                    values={formValues}
                    onAfterChange={() => null}
                    onChange={(value) => {
                        if (updateRegionsImmediately) {
                            updateSelectedRegions({
                                ...search,
                                ...value
                            });
                        } else {
                            formActions?.update(value);
                        }
                    }}
                    handleDistanceSubmit={() => onSearchSubmit}
                    setDesktopTypeBlendActive={() => null}
                    menuPlacement="top"
                />
            )}
        />
    );
};
